import { render, staticRenderFns } from "./McExploreDetail.vue?vue&type=template&id=0fede030&scoped=true&"
import script from "./McExploreDetail.vue?vue&type=script&lang=js&"
export * from "./McExploreDetail.vue?vue&type=script&lang=js&"
import style0 from "./McExploreDetail.vue?vue&type=style&index=0&id=0fede030&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fede030",
  null
  
)

export default component.exports